<div class="col">
  <div class="square-box-loader">
    <div class="square-box-loader-container">
      <div class="square-box-loader-corner-top"></div>
      <div class="square-box-loader-corner-bottom"></div>
    </div>
    <div class="square-box-loader-square"></div>
  </div>
</div>
